import dashboardApi from '@modules/dashboard/api';
import { useQuery } from '@tanstack/react-query';

const useGetConversionFunnel = (brokerageId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['dashboardCaseConversionFunnel'],
    queryFn: () => dashboardApi.getCaseConversionFunnel(brokerageId),
    retry: 2,
    // One hour
    staleTime: 1000 * 60 * 60,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useGetConversionFunnel };
